const esPhone = /^([7,6]{1})+([0-9]{8})$/
export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return esPhone.test(value)
  }
}
